module.exports = __webpack_public_path__ + "static/media/jupiler-na.6ad592a6.jpg";